import React from 'react';
import { Link } from 'react-router-dom';

interface PanelButtonProps {
  panel: string;
  disableAdd: boolean;
  disableRefreshElements: boolean;
  disableRebuildSurface: boolean;
  buttontype: boolean;
  addLink?: string;
  add?: () => void;
  refreshElements(): any;
  rebuildSurface?: () => void;
  actionName?: string;
}

export const DesignSummaryButtons = (props: PanelButtonProps) => {
  return (
    <div className="form-row-fixed-height justify-content-between mt-4 mb-0">
      <div>
        {props.addLink ? (
          <Link to={props.addLink} className="usa-button m-0">
            Add
          </Link>
        ) : (
          <button
            className="usa-button m-0"
            id={`add${props.panel}`}
            data-testid={`add${props.panel}Button`}
            disabled={props.disableAdd}
            onClick={props.add}
          >
            Add
          </button>
        )}
      </div>
      <div className="display-flex align-items-center">
        <ul className="usa-button-group usa-button-group--segmented">
          <li className="usa-button-group__item m-0">
            <button
              disabled={props.disableRefreshElements}
              data-testid="refreshElements"
              className="usa-button usa-button--outline"
              onClick={props.refreshElements}
            >
              Refresh Elements
            </button>
          </li>

          {props.rebuildSurface && (
            <li className="usa-button-group__item m-0">
              <button
                disabled={props.disableRebuildSurface}
                data-testid="rebuildSurface"
                className={props.buttontype ? 'usa-button' : 'usa-button usa-button--outline'}
                onClick={props.rebuildSurface}
              >
                {props.actionName ?? 'Rebuild Surface'}
              </button>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};
